export default __webpack_public_path__ + "static/media/logo1.53336e7b.png";